import {DefaultInteraction} from "./interaction";


export class JoinMeetingInteraction extends DefaultInteraction {

	interactionData
	metadata = {}

	rtcManager


	constructor(props) {
		super(props);
		this.rtcManager = props.rtcManager
	}

	key() {
		return "join_meeting"
	}

	runInteraction(interactionData, metadata, onSuccess, onError) {
		console.log("JoinMeetingInteraction", interactionData, metadata)

		this.rtcManager.joinRoom(interactionData.room_id).then((r) => {
			console.log("Joined room", interactionData.room_id, r)
			onSuccess(r)
		}).catch((e) => {
			console.log("Unable to join room", e)
			onError(e)
		})

		//TODO Currently locking user in place
		return false //Success/error called from promise
	}


	onProximityExit(interactable) {
		window.dispatchEvent(new CustomEvent('interaction-out', {
			detail: {
				action_type: this.key(),
			}
		}))
		this.rtcManager.onClose()
	}


	onProximityEnter(interaction, interactable) {
		//Cant be triggered by proximity
	}
}